import React, { useEffect, useState } from 'react';
import { api } from '../utils/api';
import ProductCard from '../components/ProductCard';

function ContactPopup({ onClose }) {
  const [info, setInfo] = useState(null);

  useEffect(() => {
    api.get('/settings').then(s => setInfo(s)).catch(() => setInfo({}));
  }, []);

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 380 }}>
        <div className="modal-title">📞 יצירת קשר</div>
        {!info ? (
          <p style={{ color: 'var(--text-light)' }}>טוען...</p>
        ) : (info.contact_phone || info.contact_email) ? (
          <div style={{ padding: '8px 0 16px' }}>
            {info.contact_phone && (
              <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16 }}>
                <span style={{ fontSize: 24 }}>📱</span>
                <div>
                  <div style={{ fontSize: 12, color: 'var(--text-light)', marginBottom: 2 }}>טלפון</div>
                  <a href={`tel:${info.contact_phone}`} style={{ fontWeight: 700, color: 'var(--primary-dark)', textDecoration: 'none', fontSize: 18 }} dir="ltr">{info.contact_phone}</a>
                </div>
              </div>
            )}
            {info.contact_email && (
              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <span style={{ fontSize: 24 }}>✉️</span>
                <div>
                  <div style={{ fontSize: 12, color: 'var(--text-light)', marginBottom: 2 }}>אימייל</div>
                  <a href={`mailto:${info.contact_email}`} style={{ fontWeight: 700, color: 'var(--primary-dark)', textDecoration: 'none' }} dir="ltr">{info.contact_email}</a>
                </div>
              </div>
            )}
          </div>
        ) : (
          <p style={{ color: 'var(--text-light)', padding: '16px 0' }}>פרטי הקשר טרם הוגדרו.</p>
        )}
        <div className="modal-actions">
          <button className="btn btn-cancel" onClick={onClose}>סגור</button>
        </div>
      </div>
    </div>
  );
}

export default function CatalogPage() {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCat, setSelectedCat] = useState(null);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);
  const [bannerText, setBannerText] = useState('מחירים מיוחדים למוסדות וכמויות');
  const [bannerVisible, setBannerVisible] = useState(true);
  const [showContact, setShowContact] = useState(false);

  useEffect(() => {
    api.get('/settings').then(s => {
      if (s.banner_text) setBannerText(s.banner_text);
      if (s.banner_visible === 'false') setBannerVisible(false);
    }).catch(() => {});
    api.get('/categories').then(setCategories);
  }, []);

  useEffect(() => {
    setLoading(true);
    const params = new URLSearchParams();
    if (selectedCat) params.set('category', selectedCat);
    if (search) params.set('search', search);
    api.get(`/products?${params}`).then(data => {
      setProducts(data);
      setLoading(false);
    });
  }, [selectedCat, search]);

  return (
    <div className="page">
      <h1 className="page-title">🎨 קטלוג מוצרים</h1>

      {bannerVisible && bannerText && (
        <div style={{
          background: 'linear-gradient(135deg, var(--primary-dark) 0%, var(--purple) 100%)',
          color: 'white', borderRadius: 12, padding: '14px 20px',
          marginBottom: 24, display: 'flex', alignItems: 'center',
          justifyContent: 'space-between', gap: 12, flexWrap: 'wrap',
          boxShadow: '0 4px 16px rgba(0,0,0,0.15)',
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <span style={{ fontSize: 28 }}>🏫</span>
            <div>
              <div style={{ fontWeight: 800, fontSize: 17 }}>{bannerText}</div>
              <div style={{ fontSize: 13, opacity: 0.9, marginTop: 2 }}>
                מוסדות, מרכזי פנאי ורכישה בכמויות —{' '}
                <span
                  onClick={() => setShowContact(true)}
                  style={{ textDecoration: 'underline', cursor: 'pointer', fontWeight: 700 }}>
                  צרו קשר
                </span>
                {' '}לקבלת הצעת מחיר
              </div>
            </div>
          </div>
          <button
            onClick={() => setShowContact(true)}
            style={{
              background: 'rgba(255,255,255,0.2)', border: '2px solid rgba(255,255,255,0.6)',
              color: 'white', borderRadius: 8, padding: '8px 18px',
              fontWeight: 700, fontSize: 14, cursor: 'pointer',
              transition: 'background .2s',
            }}>
            📞 צרו קשר
          </button>
        </div>
      )}

      <div className="catalog-controls">
        <input
          className="search-input"
          placeholder="🔍 חיפוש מוצר..."
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
        <div className="category-tabs">
          <button className={`cat-tab ${!selectedCat ? 'active' : ''}`} onClick={() => setSelectedCat(null)}>הכל</button>
          {categories.map(cat => (
            <button key={cat.id} className={`cat-tab ${selectedCat === cat.id ? 'active' : ''}`} onClick={() => setSelectedCat(cat.id)}>
              {cat.name}
            </button>
          ))}
        </div>
      </div>

      {loading ? (
        <div className="empty-state"><div className="icon">⏳</div><p>טוען...</p></div>
      ) : products.length === 0 ? (
        <div className="empty-state"><div className="icon">🔍</div><p>לא נמצאו מוצרים</p></div>
      ) : (
        <div className="product-grid">
          {products.map(p => <ProductCard key={p.id} product={p} />)}
        </div>
      )}

      {showContact && <ContactPopup onClose={() => setShowContact(false)} />}
    </div>
  );
}
